import React, { useEffect } from 'react';
import FormLayout from '../components/FormLayout';
import FormHeader from '../components/FormHeader';
import { useNavigate } from 'react-router-dom';
import TermsContent from '../components/TermsContent';

const TermsPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <FormLayout maxWidthClass="max-w-4xl">
      <div className="mb-6">
        <button
          onClick={() => navigate(-1)}
          className="text-gray-400 hover:text-white transition-colors flex items-center gap-2"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            />
          </svg>
          Back
        </button>
      </div>

      <FormHeader title="Terms of Service" subtitle="Last Updated: November 20, 2024" />

      <div className="max-w-none text-gray-300 mt-12 pb-12">
        <TermsContent />
      </div>
    </FormLayout>
  );
};

export default TermsPage;
